import { useState } from 'react';

import { Modal as ModalAntD, Result, Row } from 'antd';
import { Formik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';

import * as S from './styled';

import {
  createVirtualGroupDynamicPricing,
  updateVirtualGroupDynamicPricing
} from '../../../hooks/virtualgroup';
import DynamicPricingForm from '../../organisms/DynamicPricingForm/DynamicPricingForm';

const Modal: any = ModalAntD;

export interface VirtualGroupDynamicPricingPageProps {
  editValues: any;
};

const VirtualGroupDynamicPricingPage = ({ editValues }: VirtualGroupDynamicPricingPageProps) => {
  const history = useHistory();

  const { pathname }: any = useLocation();

  const [id] = useState(pathname.split('/')[3]);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState({
    status: false,
    message: '',
  });

  const onSubmit =  async (values: any) => {
    setLoading(true);

    try {
      if (editValues) {
        await updateVirtualGroupDynamicPricing(id, {
          enabled: values.dynamic_pricing.enabled,
          connector1_dynamic_pricing_id: values.dynamic_pricing.connector1_dynamic_pricing_id,
          connector2_dynamic_pricing_id: values.dynamic_pricing.connector2_dynamic_pricing_id,
          connector3_dynamic_pricing_id: values.dynamic_pricing.connector3_dynamic_pricing_id
        });
      } else {
        await createVirtualGroupDynamicPricing({
          virtual_group_id: id,
          enabled: values.dynamic_pricing.enabled,
          connector1_dynamic_pricing_id: values.dynamic_pricing.connector1_dynamic_pricing_id,
          connector2_dynamic_pricing_id: values.dynamic_pricing.connector2_dynamic_pricing_id,
          connector3_dynamic_pricing_id: values.dynamic_pricing.connector3_dynamic_pricing_id
        });
      }

      setSuccess(true);
    } catch (e: any) {
      setTimeout(
        () =>
          setError({
            status: true,
            message: 'Não foi possível atualizar o Perfil de Precificação!',
          }),
        1500,
      );
    } finally {
      setTimeout(() => setLoading(false), 1500);
    }
  };

  return (
    <S.Wrapper>
      <Formik
        validateOnMount
        initialValues={{
          dynamic_pricing: {
            enabled: false,
            type: 'station',
            connector1_dynamic_pricing_id: undefined,
            connector2_dynamic_pricing_id: undefined,
            connector3_dynamic_pricing_id: undefined
          }
        }}
        validate={(values) => {
          const errors: any = {};
          let hasError = false;

          if (values.dynamic_pricing.enabled) {
            errors.dynamic_pricing = {};

            if (values.dynamic_pricing.type === 'station' && !values.dynamic_pricing.connector1_dynamic_pricing_id) {
              hasError = true;

              errors.dynamic_pricing.connector1_dynamic_pricing_id = 'Selecione um perfil de precificação';
            }

            if (values.dynamic_pricing.type === 'connectors') {
              if (!values.dynamic_pricing.connector1_dynamic_pricing_id) {
                hasError = true;
                errors.dynamic_pricing.connector1_dynamic_pricing_id = 'Selecione um perfil de precificação';
              }
              if (!values.dynamic_pricing.connector2_dynamic_pricing_id) {
                hasError = true;
                errors.dynamic_pricing.connector2_dynamic_pricing_id = 'Selecione um perfil de precificação';
              }
              if (!values.dynamic_pricing.connector3_dynamic_pricing_id) {
                hasError = true;
                errors.dynamic_pricing.connector3_dynamic_pricing_id = 'Selecione um perfil de precificação';
              }
            }
          }

          return hasError ? errors : {};
        }}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <DynamicPricingForm
              loading={false}
              editValues={editValues}
            />

            <Row style={{ marginTop: 32, justifyContent: 'space-between' }}>
              <S.Button
                disabled={loading}
                size='large'
                danger
                onClick={history.goBack}>
                Cancelar
              </S.Button>

              <S.Button
                disabled={loading}
                key='submit'
                size='large'
                type='primary'
                htmlType='submit'>
                Salvar Perfil de Precificação
              </S.Button>
            </Row>
          </form>
        )}
      </Formik>

      <Modal visible={success} onOk={() => {}} onCancel={() => {}} closable={false} footer={null}>
        <Result
          status='success'
          title='Perfil de Precificação atualizado com sucesso!'
          extra={[
            <S.Button
              type='primary'
              key='console'
              size='large'
              onClick={() => setSuccess(false)}
            >
              Ver detalhe
            </S.Button>,
          ]}
        />
      </Modal>

      <Modal visible={error.status} closable={false} footer={null}>
        <Result
          status='error'
          title={error.message}
          extra={[
            <S.Button
              type='primary'
              key='primary'
              size='large'
              onClick={() =>
                setError({
                  status: false,
                  message: '',
                })
              }
            >
              Voltar ao detalhe
            </S.Button>,
          ]}
        />
      </Modal>
    </S.Wrapper>
  );
};

export default VirtualGroupDynamicPricingPage;